import { useQuery } from 'react-query';
import { ExtractFnReturnType, QueryConfig } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const getSubordinateUnitsViaID = (unitId: number | undefined): Promise<IGetSubordinateUnitsViaUnitID[]> => {
  return axiosDefaultApi.get(`/api/SubUnits/GetSubUnitsViaUnitID/${unitId}`);
};

type QueryFnType = typeof getSubordinateUnitsViaID;

type UseGetSubordinateUnitsViaIDOptions = {
  unitId: number;
  config?: QueryConfig<QueryFnType>;
};

export const useGetSubordinateUnitsViaID = ({ unitId , config }: UseGetSubordinateUnitsViaIDOptions) => {
  const {addNotification, setIsNotificationVisible} = useNotification();
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    ...config,
    queryKey: [`getSubordinateUnitsViaID_${unitId}`],
    queryFn: () => getSubordinateUnitsViaID(unitId),
    onError: (error) =>{
      addNotification(`Υπήρξε κάποιο πρόβλημα στην ανάκτηση των Subordinate Units via ID.`, 500);
      setIsNotificationVisible(true)
      console.log(error)
    }
  });
};

export interface IGetSubordinateUnitsViaUnitID {
  description: string;
  unitTypeID: number;
  relName: string;
  comments: string;
  id: number;
}